import { render, staticRenderFns } from "./PasteMenu.vue?vue&type=template&id=5b2d5272&scoped=true&"
import script from "./PasteMenu.vue?vue&type=script&lang=js&"
export * from "./PasteMenu.vue?vue&type=script&lang=js&"
import style0 from "./PasteMenu.vue?vue&type=style&index=0&id=5b2d5272&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2d5272",
  null
  
)

export default component.exports